// Formas de pago que puede elegir un interesado en una propiedad en venta.
// Si agregas o cambias una opción aquí, agrégala también en
// backend/src/controllers/contactsController.js (FORMAS_PAGO).
export const FORMAS_PAGO = [
  { value: "INFONAVIT", label: "Infonavit" },
  { value: "FOVISSSTE", label: "Fovissste" },
  { value: "BANCARIO", label: "Bancario" },
  { value: "CFE", label: "CFE" },
  { value: "RECURSOS_PROPIOS", label: "Recursos propios" },
  { value: "OTRO", label: "Otro" },
];

export const etiquetaFormaPago = (value) =>
  FORMAS_PAGO.find((f) => f.value === value)?.label || value;
